import { CnNavBar } from '@/components/cn-nav-bar';

export default CnNavBar;
